import request from '@/utils/request'

// 获取设备类型列表
export const getEquiplLists = (data) => {
    return request({
        url: '/equip/lists',
        params: data
    })
}

// 获取设备类型选项
export const getEquipOptionlLists = (data) => {
    return request({
        url: '/equip/option/lists',
        params: data
    })
}

// 获取设备类型-型号tree
export const getEquipModelTree = (data) => {
    return request({
        url: '/equipModel/tree',
        params: data
    })
}

// 获取设备类型分组
export const getEquipOptionTreeLists = (data) => {
    return request({
        url: '/equip/option/tree/lists',
        params: data
    })
}

// 设备管理-详情
export const getEquipDetail = (id) => {
    return request({
        url: `/equip/${id}`
    })
}

// 设备管理-修改
export const putEquip = (data) => {
    return request({
        url: '/equip/manage',
        method: 'PUT',
        data
    })
}

// 设备管理-添加
export const addEquip = (data) => {
    return request({
        url: '/equip/manage',
        method: 'POST',
        data
    })
}

// 设备管理-删除
export const delEquip = (id) => {
    return request({
        url: `/equip/manage/${id}`,
        method: 'DELETE'
    })
}

// 获取设备类型选项
export const getEquipCurrent = (data) => {
    return request({
        url: `/equip/current/data/${data}`
    })
}

// 获取设备图表
export const getEquiplChart = (data) => {
    return request({
        url: `/equip/data/chart${data.equipId ? '/' + data.equipId : ''}`,
        params: data
    })
}

// 获取设备列表
export const getEquiplListsByTable = (data) => {
    return request({
        url: '/equip/data/lists',
        params: data
    })
}

// 获取报警日志
export const getWarningLogLists = (id, data) => {
    return request({
        url: `/warning/log/lists${id && '/' + id}`,
        params: data
    })
}

// 获取监控图表
export const getEquiplChartIndex = (data) => {
    return request({
        url: '/data/chart/lists',
        params: data
    })
}

// 操作日志
export const getOperationLogList = (data) => {
    return request({
        url: '/operation/log/lists',
        params: data
    })
}

// 设备详情
export const getEquipDetail2 = (data) => {
    return request({
        url: '/equip/get/detail',
        params: data
    })
}

// 获取主钟
export const getMainClk = (data) => {
    return request({
        url: '/equip/control/master',
        params: data,
        timeout: 5 * 1000
    })
}

// 设备控制-设置
export const patchMainClk = (data) => {
    return request({
        url: '/equip/control/manage',
        method: 'PATCH',
        data
    })
}

/**
 * 下载导入模板
 */
export const getEquipTemplateUrl = () => {
    return request({
        url: '/equip/down/excel/template'
    })
}

// 设备型号-导出
export const importsEquip = (data) => {
    return request({
        url: '/equip/excel/imports',
        method: 'POST',
        data
    })
}

// 同步采集服务
export const getEquipService = (data) => {
    return request({
        url: '/equip/sync/client/service',
        params: data
    })
}

// 获取设备下子表最新数据
export const getTableCurrent = (data) => {
    return request({
        url: `/equip/current/table/data/${data}`
    })
}

// 设备-一键排序
export const patchEquipment = (data) => {
    return request({
        url: '/equip/manage',
        method: 'PATCH',
        data
    })
}

// 设备网络离线预警通知
export const patchOfflineWarning = (data) => {
    return request({
        url: '/equip/offline/warning',
        method: 'PATCH',
        data
    })
}

// 设备数据异常预警通知
export const patchDataWarning = (data) => {
    return request({
        url: '/equip/data/warning',
        method: 'PATCH',
        data
    })
}

// 获取链路
export const getTraceLine = (data) => {
    return request({
        url: '/trace/line'
    })
}

// 批量绑定子表
export const patchBindSubtable = (data) => {
    return request({
        url: '/equip/table/bind',
        method: 'PATCH',
        data
    })
}
